import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import styles from "./styles.module.css";

function OpenJobDetails({ job, visible, onHide, applicantSigninUrl }) {
    const parseList = (value) => {
        if (!value) return [];

        return String(value)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    };

    const DetailItem = ({ label, value }) => (
        <div className={styles.openJobDetailItem}>
        <span className={styles.openJobDetailLabel}>{label}</span>
        <p className={styles.openJobDetailValue}>{value || "Not informed"}</p>
        </div>
    );

    const DetailList = ({ label, items }) => (
        <div className={styles.openJobDetailItem}>
        <span className={styles.openJobDetailLabel}>{label}</span>

        {items.length > 0 ? (
            <div className={styles.openJobTags}>
            {items.map((item) => (
                <span key={item} className={styles.openJobTag}>
                {item}
                </span>
            ))}
            </div>
        ) : (
            <p className={styles.openJobDetailValue}>Not informed</p>
        )}
        </div>
    );

    const OpenJobSkeleton = () => (
        <div className={styles.openJobDetails}>
        <Skeleton width="50%" height="24px" className="mb-4" />
        <Skeleton height="80px" className="mb-3" />
        <Skeleton height="80px" className="mb-3" />
        <Skeleton height="80px" className="mb-3" />
        </div>
    );

    const skills = parseList(job?.skills);
    const languages = parseList(job?.languages);

    return (
        <Dialog
        visible={visible}
        header={job?.jobTitle || "Job Details"}
        onHide={onHide}
        dismissableMask
        className={styles.openJobDialog}
        >
        {!job ? (
            <OpenJobSkeleton />
        ) : (
            <div className={styles.openJobDetails}>
            <section className={styles.openJobSection}>
                <h4>{job.jobTitle || "Job Opportunity"}</h4>

                <DetailItem label="Job Description" value={job.jobDescription} />

                <DetailItem label="Offer Rate" value={job.offerRate}/>

                <DetailItem label="Location" value={job.location}/>

                <DetailList label="Skills" items={skills} />

                <DetailList label="Languages" items={languages} />

                <DetailItem label="Responsibilities" value={job.responsibilities} />

                <DetailItem label="Requirements" value={job.requirements} />
            </section>

            <div className="job-offer-apply-btn">
                <Button
                label="Apply now"
                onClick={() =>
                    window.open(applicantSigninUrl, "_blank", "noopener,noreferrer")
                }
                />
            </div>
            </div>
        )}
        </Dialog>
    );
}

export default OpenJobDetails;